import Vue from 'vue';

// eslint-disable-next-line no-nested-ternary

Vue.filter('striphtml', (value) => {
    const div = document.createElement('div');
    div.innerHTML = value;
    const text = div.textContent || div.innerText || '';
    return text;
});

Vue.filter('truncate', (value, length, clamp) => {
    const currentClamp = clamp !== undefined ? clamp : '...';
    const node = document.createElement('div');
    node.innerHTML = value;
    const content = node.textContent;
    return content.length > length ? content.slice(0, length) + currentClamp : content;
});

Vue.filter('lowercase', (value) => value.toLowerCase());
